import { SidebarMenuItem } from '@/resources/types'
import * as S from './styles'

interface ExternalLinkProps {
  link: SidebarMenuItem
}

const ExternalLink = ({ link, ...props }: ExternalLinkProps) => {
  return (
    <a
      href={link.to}
      id={link.id}
      target="_blank"
      rel="noopener noreferrer"
      onClick={link?.onClick}
      {...props}
    >
      <span>{link.text}</span>
      {link.icon && <S.ExternalLinkIcon icon={link.icon} color="transparent" />}
    </a>
  )
}

export default ExternalLink
